module.exports = __webpack_public_path__ + "static/rc-1-005dd81be53b92eb4c4e62814855e180.jpg";